import React from "react";

import ExternalShareDialog from "./ExternalShareDialog";
import ExternalShareNavMenu from "./ExternalShareNavMenu";
import type { ExternalShareMenuProps } from "./types";

const ExternalShareMenu = ({ variant, ...props }: ExternalShareMenuProps) => {
  const Component =
    variant === "menu" ? ExternalShareNavMenu : ExternalShareDialog;
  return <Component {...props} />;
};

export default ExternalShareMenu;
